import
  React
from 'react';

import
  styled
from 'styled-components';

import
  PropTypes
from 'prop-types';

import {
  CustomColors
} from '../../constants';

import {
  Text,
  VContainer
} from '@vodacom/web-common';

const Container = styled(VContainer)`
  position: absolute;
  top: ${props => props.top};
  right: 0;
  left: 0;
  z-index: 6;
  transition: top 0.5s;
  border-radius: 0 0 4px 4px;
`;

export const PopUpBanner = props => (

  <Container
    backgroundColor={props.backgroundColor}
    padding={'16px'}
    width={'100%'}
    boxSizing={'border-box'}
    top={props.show ? '0' : '-50%'}
    show={props.show}>

      <Text
        color={props.textColor}
        fontSize={'16px'}
        fontFamily={'Roboto'}
        lineHeight={'24px'}
        padding={'0 0 12px'}
        fontWeight={'bold'}>

        {props.text}
      </Text>

      <VContainer
        margin={'auto 0 0 auto'}>

        <Text
          color={props.textColor}
          fontSize={'16px'}
          fontFamily={'Roboto'}
          onClick={props.onClose}
          fontWeight={'bold'}>

          {'Dismiss'}
        </Text>
      </VContainer>

  </Container>
);

PopUpBanner.propTypes = {
  text: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string,
  textColor: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  show: PropTypes.bool
};

PopUpBanner.defaultProps = {
  text: 'Your One-Time PIN has been resent. Please check your inbox.',
  backgroundColor: CustomColors.Blue2,
  textColor: CustomColors.White,
  onClose: () => {}
};